import { axios } from "@/plugins/axios";

function getContractDetails(contractId) {
    return axios.post(
        "?Mode=MeinServicebereich&Function=GetVertragDetails",
        "vertragsnummer=" + contractId
    );
}

function getContractTransactions(contractId, year) {
    return axios.post(
        "?Mode=MeinServicebereich&Function=GetVertragUmsaetze",
        "vertragsnummer=" + contractId + "&jahr=" + year
    );
}

function getContracts() {
    return axios.post("?Mode=MeinServicebereich&Function=GetVertraege");
}

export { getContractDetails, getContractTransactions, getContracts };
